<template>
  <withTopNav :leftText="$t('Message.leftText')" class="text-13" fixed>
    <div
      class="fixed-rt-[15px_15px] z-10"
      style="padding-top: calc(env(safe-area-inset-top) / 2)"
    >
      <img :src="clean" class="w-[24px] h-[24px]" @click="showClean = true" />
    </div>

    <div>
      <NoData v-if="dataList.length === 0" :text="$t('Message.NoMessages')" />
      <van-list
        v-model:loading="isLoading"
        :finished="finished"
        :loading-text="$t('Common.Loading')"
        @load="loadMore"
      >
        <div class="mx-5 mt-7">
          <div
            v-for="{ content, id, createTime, type, number } in dataList"
            :key="id"
            class="mb-[24px] flex"
          >
            <Image :src="trumpet" alt="" class="w-[48px] h-[48px] mr-3" />
            <div class="flex-1 overflow-hidden">
              <div class="flex items-center justify-between text-sm mb-2.5">
                <span class="text-white text-[14px] flex items-center">
                  {{ $t("Message.SystemMessage") }}
                  <img
                    v-if="isNewMessage(number)"
                    :src="newIcon"
                    alt=""
                    class="w-5 h-auto ml-2"
                  />
                </span>
                <span class="text-white/75 my-1 text-[11px]">
                  {{ formatDate(createTime) }}
                </span>
              </div>
              <div
                class="text-white whitespace-pre-wrap break-words bg-[#2C7952]/10 rounded-[8px] p-3"
              >
                {{ formatContent(type, content) }}
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <van-popup v-model:show="showClean" style="background: transparent; border: none">
      <CleanMessage @confirm="resetAndLoadMessages" @close="showClean = false" />
    </van-popup>
  </withTopNav>
</template>

<script setup lang="ts">
import i18n from "@/i18n";
import { formatter } from "@/utils";
import withTopNav from "@/layouts/withTopNav.vue";
import { getMessageList, updateMessageState, deleteMessage } from "@/api/message";
import trumpet from "./images/trumpet.png";
import newIcon from "./images/newIcon.png";
import clean from "./images/clean.png";
import NoData from "@/components/NoData/index.vue";
import dayjs from "dayjs";
import debounce from "lodash-es/debounce";
import CleanMessage from "./compontents/CleanMessage.vue";
interface MessageData {
  id: number;
  state: number;
  content: string;
  createTime: string;
  type: string;
  number: number;
}

const dataList = ref<MessageData[]>([]);
const finished = ref(false);
const current = ref(0);
const t = i18n.global.t;
const subscriber = ref<any>({});
const isLoading = ref<any>(false);
const showClean = ref(false);

const loadMore = debounce(async (props: { pageIndex: number } | any) => {
  if (finished.value) return;
  isLoading.value = true;
  try {
    const params = {
      pageIndex: props?.pageIndex || current.value,
      pageSize: 10,
      count: 0,
    };
    const { code, data } = await getMessageList(params);
    console.log("getMessageList result:", data);
    if (code === 1) {
      subscriber.value = data.subscriber;
      current.value++;
      dataList.value = [...dataList.value, ...data.page.data];
      if (data.page.data < 10) {
        finished.value = true;
      }
      modifyMessageState(data.page.data.map((item) => item.number));
    }
  } finally {
    isLoading.value = false;
  }
}, 500);
const modifyMessageState = async (list: number[]) => {
  if (
    Number(list[0]) > Number(subscriber.value.latestRead) &&
    !subscriber.value.readList.includes(list[0])
  ) {
    await updateMessageState(list);
  }
};

const replaceAmount = (content: string, amount: number) => {
  return content.replace("amountReplace", formatter().format(amount));
};

const resetAndLoadMessages = async () => {
  current.value = 0;
  dataList.value = [];
  finished.value = false;
  await deleteMessage([0]);
  showClean.value = false;
  loadMore({ pageIndex: 0 });
};

const isNewMessage = (number: number) => {
  return (
    number > subscriber.value.latestRead && !subscriber.value.readList.includes(number)
  );
};

const formatDate = (date: string) => {
  return dayjs(date).format("YYYY-MM-DD HH:mm");
};

const formatContent = (type: string, content: string) => {
  return type === "Default"
    ? content
    : replaceAmount(
        t(`messageInfo.${JSON.parse(content).template}`),
        JSON.parse(content).params
      );
};
</script>

<style scoped></style>
